var loadingArtContext; // Loading screen animation

// WIP Aesthetic: Procedural Loading Animation
function initLoadingArt() {
  const canvas = document.getElementById('loading-art');
  if (canvas) {
    loadingArtContext = canvas.getContext('2d');
    animateLoadingArt();
  }
}

function animateLoadingArt() {
  if (!loadingArtContext) return;
  
  const ctx = loadingArtContext;
  const width = ctx.canvas.width;
  const height = ctx.canvas.height;
  
  // Clear canvas with fade-out effect
  ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
  ctx.fillRect(0, 0, width, height);
  
  // Draw animated grid for "build in progress" aesthetic
  ctx.strokeStyle = '#00ffff';
  ctx.lineWidth = 1;
  
  const time = Date.now() * 0.001;
  const gridSize = 32;
  
  // Animate grid lines
  for (let x = 0; x < width; x += gridSize) {
    for (let y = 0; y < height; y += gridSize) {
      const pulse = Math.sin(time + (x + y) * 0.02) * 0.5 + 0.5;
      ctx.globalAlpha = 0.2 + pulse * 0.6;
      
      // Draw ship construction grid
      ctx.strokeStyle = `hsl(180, 100%, ${30 + pulse * 30}%)`;
      
      // Central focus effect
      const dist = Math.sqrt((x - width/2)**2 + (y - height/2)**2);
      const sizeMod = Math.max(0.5, 1 - dist / (width/2));
      
      ctx.strokeRect(
        x + (gridSize - gridSize * sizeMod * pulse) / 2,
        y + (gridSize - gridSize * sizeMod * pulse) / 2,
        gridSize * sizeMod * pulse,
        gridSize * sizeMod * pulse
      );
    }
  }
  ctx.globalAlpha = 1;
  
  // Draw loading signature
  ctx.fillStyle = '#00ffff';
  ctx.font = '12px JetBrains Mono';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('BOOTSTRAPPING NEURAL PERSONALITIES', width/2, height/2 - 16);
  ctx.fillText('⚡ MISSION ASSETS LOADING ⚡', width/2, height/2 + 16);
  
  requestAnimationFrame(animateLoadingArt);
}

// Boyer Sequence: Boot Loader Animation
function addBootMessage(message, type = 'info') {
  const bootSequence = document.getElementById('boot-sequence');
  const messageElement = document.createElement('div');
  messageElement.className = `boot-log ${type}`;
  messageElement.textContent = message;
  bootSequence.appendChild(messageElement);
  
  // Scroll to bottom
  bootSequence.scrollTop = bootSequence.scrollHeight;
  
  // Animate
  setTimeout(() => {
    messageElement.classList.add('visible');
  }, 50);
}

// Character loading progress
function updateCharacterProgress(character, percent) {
  const container = document.getElementById('character-loading');
  let charElement = document.getElementById(`char-${character}`);
  
  if (!charElement) {
    charElement = document.createElement('div');
    charElement.id = `char-${character}`;
    charElement.className = 'character-item';
    charElement.innerHTML = `└─ ─ ${character.replace('-', ' ').toUpperCase()} ►\n    <div class="character-progress">\n      <div class="character-bar ${character}-bar"></div>\n    </div>`;
    container.appendChild(charElement);
  }
  
  const charBar = container.querySelector(`#char-${character} .${character}-bar`);
  if (charBar) {
    charBar.style.width = `${percent}%`;
  }
}

// Update progress
function updateProgress(percent, text) {
  const loadingText = document.getElementById('loading-text');
  const loadingProgress = document.getElementById('loading-progress');
  
  if (loadingProgress) {
    loadingProgress.style.width = `${percent}%`;
  }
  
  if (loadingText) {
    loadingText.textContent = text;
  }

  // Simulate boot sequence
  if (percent < 10) {
    addBootMessage('▌█ BOOTSTRAP INITIATED', 'info');
    addBootMessage('▌█ MEMORY MAP HALLOC RIPPLE', 'info');
  } else if (percent < 20) {
    addBootMessage('▌█ SIGNAL INJECTORS ACTIVATED', 'info');
    addBootMessage('▌█ NEURAL INTERFACE ONLINE', 'success');
  } else if (percent < 30) {
    addBootMessage('▌█ LOADING CONTRACT PROFILE...', 'info');
  } else if (percent < 40) {
    addBootMessage('▌█ DISTRIBUTED PRESENCE ENGAGED', 'warning');
    updateCharacterProgress('honey-badger', 10 + Math.random() * 20);
  } else if (percent < 60) {
    addBootMessage('▌█ ASSET CHAIN PROVISIONED', 'success');
    updateCharacterProgress('honey-badger', 80 + Math.random() * 20);
    updateCharacterProgress('octopus', 10 + Math.random() * 40);
    updateCharacterProgress('elephant', 0);
  } else if (percent < 80) {
    updateCharacterProgress('honey-badger', 100);
    updateCharacterProgress('octopus', 60 + Math.random() * 40);
    updateCharacterProgress('elephant', 20 + Math.random() * 30);
    updateCharacterProgress('mantis-shrimp', 0);
  } else {
    updateCharacterProgress('octopus', 100);
    updateCharacterProgress('elephant', 60 + Math.random() * 40);
    updateCharacterProgress('mantis-shrimp', 30 + Math.random() * 30);
    updateCharacterProgress('ant', 0);
  }
}

// Initialize loading screen
initLoadingArt();

export { updateProgress, updateCharacterProgress };
